module.exports = __webpack_public_path__ + "img/image (34).ce000931.jpg";